import { useQuery } from "@tanstack/react-query";

import { config } from "@/config/config";
import { getClientById } from "@/pages/clients/clients.api";

import { useAuth } from "./auth.hooks";
import { hasPartnerPortalAccess } from "./partner-portal-roles";

export function usePartnerBranding() {
  const { auth } = useAuth();
  const isPartnerPortalUser = hasPartnerPortalAccess(auth.roles);
  const organizationRootId = auth.organization_root_id?.trim();

  const { data: organization } = useQuery({
    queryKey: ["partner-branding", organizationRootId],
    queryFn: () => getClientById(organizationRootId as string),
    enabled: isPartnerPortalUser && Boolean(organizationRootId),
    staleTime: 5 * 60 * 1000,
  });

  const partnerLogoUrl = organization?.document?.company_logo;

  return {
    logoUrl: partnerLogoUrl || config.logoUrl,
    brandName: (isPartnerPortalUser && organization?.name) || config.brandName,
  };
}
